import React, { useEffect } from "react";
import ProjectCard from "./ProjectCard";
import styles from "./Projects.module.css";
import OBrace from "../FakeTags/Brace/OBrace";
import CBrace from "../FakeTags/Brace/CBrace";
import AOS from "aos";
import "aos/dist/aos.css";

function Projects() {
  useEffect(() => {
    AOS.init({
      duration: 200,
      // easing: 'ease-in-sine',
      // delay: 100,
    });
    AOS.refresh();
  }, []);

  return (
    <div className={styles.container} id="projects">
      <h1 className={styles.head}>Projects</h1>
      <OBrace />

      <ul className={styles.projectsGrid}>
        <li data-aos="zoom-in" data-aos-delay="100">
          <ProjectCard
            imgName="img1"
            projectName="Hamagi"
            view="https://hamagi.netlify.app/"
            code="https://github.com/raghavaggarwal2308/Hamagi"
            showCode={true}
            showProject={true}
          />
        </li>
        <li data-aos="zoom-in" data-aos-delay="200">
          <ProjectCard
            imgName="img2"
            projectName="Portfolio"
            view="https://raghavaggarwal.netlify.app/"
            code="https://github.com/raghavaggarwal2308/MyPortfolio"
            showCode={false}
            showProject={true}
          />
        </li>
        <li data-aos="zoom-in" data-aos-delay="300">
          <ProjectCard
            imgName="img3"
            projectName="URL Shortener"
            view="https://shhortify.herokuapp.com/"
            code="https://github.com/raghavaggarwal2308/url-shortener"
            showCode={true}
            showProject={true}
          />
        </li>
        <li data-aos="zoom-in" data-aos-delay="400">
          <ProjectCard
            imgName="img4"
            projectName="Drawing Tool"
            view="https://collabdraww.herokuapp.com/"
            code="https://github.com/raghavaggarwal2308/drawingapp"
            showCode={true}
            showProject={true}
          />
        </li>
        <li data-aos="zoom-in" data-aos-delay="500">
          <ProjectCard
            imgName="img5"
            projectName="Coming Soon"
            view="https://www.google.com/"
            code="https://www.google.com/"
            showCode={false}
            showProject={false}
          />
        </li>
        {/* <li data-aos="zoom-in" data-aos-delay="600">
          <ProjectCard
            imgName="img6"
            projectName="Drawing Tool"
            view="https://www.google.com/"
            code="https://www.google.com/"
            showCode={true}
          />
        </li> */}
      </ul>
      <CBrace />
    </div>
  );
}

export default Projects;
